import React from "react";
import Footer from "components/Footer";
import Project from "components/Project";
import ProjectData from "utility/Project-data";
import arrow from "../assets/img/arrow.svg";
import photo from "../assets/img/photo.png"


class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      showBio: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleBio = this.toggleBio.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  toggleBio() {
    this.setState({
      showBio: !this.state.showBio
    });
    window.scrollTo(0, 0)
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const projects = ProjectData.slice(0, 4);
    return this.state.showBio ?
      (
        <div id="page" className="page">
          <div className="home">
            <div className="container" >
              <div className="section" style={{ marginTop: "3%", height: "110vh" }}>
                <div className="row">
                  <div className="col-md-12 col-lg-8">
                    <div>
                      <h5 className="home-heading">
                        Hi, my name is Celina Cywinska. I am currently studying Computer Science at the Polish-Japanese Academy of Information Technology.
                      </h5>
                      <div style={{ height: "30px" }}></div>
                      <h5 className="home-heading">
                        My greatest interest is Web Development, but I am currently exploring ML.
                      </h5>
                      <div style={{ height: "30px" }}></div>

                      <h5 className="home-heading">
                        Below, you can see my technology stack;
                      </h5>
                      <div style={{ height: "30px" }}></div>
                      <h5>
                        Main Language: Java, Javascript
                      </h5>
                      <h5>
                        Library/Framework: React (and react based libs), React Native, Express
                      </h5>

                      <h5>
                        Misc: Various Popular DBs, AWS services.
                      </h5>
                      <div style={{ height: "40px" }}></div>

                    </div>
                    <div className="bio-btn">
                      <a onClick={this.toggleBio} >Return Home </a><img width="15px" src={arrow}></img>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-4">
                      <img style={{ width: "90%" }} src={photo} />
                    </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      ) :
      (
        <div id="page" className="page">
          <div className="home">
            <div className="container" >
              <div className="section" style={{ marginTop: "10%", height: "70vh" }}>
                <div className="row">
                  <div className="col-md-12 col-lg-7">
                    <h5 className="home-heading">
                      Hi! I am Celina. You can see what I worked on here.	&#128075;
                    </h5>
                    <p className="home-desc">I'm always interested in new fun projects! </p>
                    <div className="button-block">
                    </div>
                    <div className="bio-btn">
                      <a onClick={this.toggleBio} >My Bio </a><img width="15px" src={arrow}></img>
                    </div>

                  </div>
                </div>
              </div>
              <div className="section">
                <div className="row">
                  <div className="col">
                    <div className="heading">
                      <hr className="heading-line" />
                      <h5 className="heading-text">Personal and Professional Projects</h5>
                    </div>
                  </div>
                </div>
              </div>

              {projects.map(project => (
                <Project
                  key={project.id}
                  name={project.name}
                  category={project.category}
                  description={project.description}
                  image={project.image}
                  imageAlt={project.imageAlt}
                  url={project.url}
                  altUrl={project.altUrl}
                  right={project.right}
                />
              ))}

              <div className="section">
                <div className="heading">
                  <hr className="heading-line" />
                  <h5 className="heading-text">Contact Me</h5>
                </div>
              </div>
              <div className="section contact pt-0">
                <div className="row">
                  <div className="col-md-12 col-lg-6">
                    <p className="contact-text">
                      I am all about learning and new challenges. If you have any projects or opportunities, don't hesitate to reach out!
                    </p>
                    <div className="button-block">
                      <span className="button-text">celinacywinska@gmail.com</span>
                      <div className="button-mask" />
                      <span className="button-icon">
                        <i className="fas fa-long-arrow-alt-right" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      );
  }
}

export default Home;
